 <template>
  <v-dialog
    :value="value"
    @input="setValue"
    persistent
    max-width="600px"
  >
    <v-toolbar color="primary" dark dense>
      <v-toolbar-title>Подтвердите действие</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="noCallBack">mdi-close</v-icon>
    </v-toolbar>
    <v-card>
      <v-card-title class="headline">
        Запрошенное действие требует подтверждения
      </v-card-title>
      <v-card-text class=" black--text">
        {{message}}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="secondary"
          outlined
          @click="noCallBack"
        >
          Нет
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="okCallBack"
        >
            Да
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'sysConfirmDialog',
  data () {
    return {}
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    okCallBack: {
      type: Function,
      default: function () {
        this.$emit('input', false)
      }
    },
    noCallBack: {
      type: Function,
      default: function () {
        this.$emit('input', false)
      }
    }
  },
  watch: {
    value (val) {
      console.log('Value in ConfirmDialog changed to ', val)
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    console.log('sysConfirmDialog mounted')
  }
}
</script>
